import { render, staticRenderFns } from "./RecHeader.vue?vue&type=template&id=6112fe04&"
import script from "./RecHeader.vue?vue&type=script&lang=js&"
export * from "./RecHeader.vue?vue&type=script&lang=js&"
import style0 from "./RecHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports